var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-slider',{attrs:{"title":"Width (%)","percent":true,"snapTo":0.05},model:{value:(_vm.width),callback:function ($$v) {_vm.width=$$v},expression:"width"}})}
var staticRenderFns = []

export { render, staticRenderFns }